module.exports = __webpack_public_path__ + "frontend/images/pattern/white.jpg?e43d6ade9979951bfdec63e512cd0548";